import axios from './axiosInstance'; 
import authService from './authService';
// استيراد الكائن الأساسي إذا لزم الأمر

// 1️⃣ وضع جميع الـ Imports والتعريفات الأساسية في أعلى الملف تماماً لإرضاء ESLint
export const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.hawala-ar.com';

/**
 * 🔑 دالة مركزية ومحمية لإنشاء الـ Auth Header بالتنسيق القياسي الذي يقبله Axios
 */
const getAuthHeader = () => {
  const token = localStorage.getItem('token'); // جلب الـ access_token فقط
  return {
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
      'Content-Type': 'application/json'
    }
  };
};



export const ENDPOINTS = {
    AUTH: {
        SIGNUP: '/auth/signup',
        LOGIN: '/auth/login',
        FORGOT_PASSWORD: '/auth/forgot-password',
        RESET_PASSWORD: '/auth/reset-password-confirm',
        SIGNOUT: '/auth/signout',
        DELETE_ACCOUNT: '/auth/delete-account',
        REFRESH_TOKEN: '/auth/refresh',
        VERIFY_OTP: '/auth/verify-otp',
        PENDING_COMPANIES: '/auth/super-admin/pending-companies', 
        APPROVE_COMPANY: (companyId) => `/auth/approve-company/${companyId}`,
        UPDATE_SUPER_ADMIN: '/auth/super-admin/update',
    },
    COMPANY_BANKS: {
        GET_ALL: '/company-banks/',
        CREATE: '/company-banks/',
        UPDATE: (bankId) => `/company-banks/${bankId}`,
        DELETE: (bankId) => `/company-banks/${bankId}`,
        ARCHIVED_ITEMS: '/company-banks/archived/archived-items',
        RESTORE: (bankId) => `/company-banks/archived/${bankId}/restore`,
    },
    VENDORS: {
        GET_ALL: '/vendors/',
        CREATE: '/vendors/',
        UPDATE: (vendorId) => `/vendors/${vendorId}`,
        DELETE: (vendorId) => `/vendors/${vendorId}`,
        RESTORE: (vendorId) => `/vendors/${vendorId}/restore`,
    },
    CONTAINERS: {
        GET_ALL: '/containers/',
        CREATE: '/containers/',
        UPDATE: (containerId) => `/containers/${containerId}`,
        DELETE: (containerId) => `/containers/${containerId}`,
        RESTORE: (containerId) => `/containers/${containerId}/restore`,
        GET_SINGLE: (containerId) => `/profile-settings/containers_name/${containerId}`,
    },
    CONTAINER_VENDOR: {
        LINK: (containerId, vendorId) => `/profile-settings/containers_vendor/${containerId}/link-vendor/${vendorId}`,
        GET_DOCUMENTS: (containerId) => `/profile-settings/containers_vendor/${containerId}/documents`,
        UNLINK: (containerId, vendorId) => `/profile-settings/unlink/containers_file/${containerId}/unlink-vendor/${vendorId}`,
    },
    INVOICE_CONNECT: {
        GET_VENDORS: (containerId) => `/invoice-connect/invoice-connect/${containerId}/vendors`,
        LINK_INVOICE: (invoiceId, containerId) => `/invoice-connect/invoice-connect/invoices/${invoiceId}/link-container/${containerId}`,
        UNLINK_INVOICE: (invoiceId) => `/invoice-connect/invoice-connect/invoices/${invoiceId}/unlink-container`,
    },
    INVOICES: {
        GET_ALL: '/all-invoices/invoices',
        CREATEINVOICE: '/invoices/',
        GET_BY_ID: (invoiceId) => `/invoices/${invoiceId}`,
        UPDATE: (invoiceId) => `/invoices/${invoiceId}`,
        DELETE: (invoiceId) => `/invoices/${invoiceId}`,
        GET_PI_INVOICES: (invoiceId) => `/invoices/${invoiceId}/pi-invoices`,
        RESTORE: (invoiceId) => `/invoices/${invoiceId}/restore`,
    },
    PI_INVOICES: {
        UPLOAD_PI: '/pi_invoice/upload-pi',
        GET_UNLINKED: '/pi_invoice/unlinked',
        GET_BY_ID: (piId) => `/pi_invoice/${piId}`,
        UPDATE: (piId) => `/pi_invoice/${piId}`,
       // في ملف الـ ENDPOINTS
        DELETE: (piId) => `/pi_invoice/${piId}/`,
        RESTORE: (invoiceId) => `/pi_invoice/${invoiceId}/restore`,
    },
    BANKS_MANAGEMENT: {
        CREATE_TRANSFER: '/banks/',
        GET_TRANSFERS: '/banks/',
        ARCHIVE_COMBINED_PDF: '/banks/archive-combined-pdf',
        UPDATE_TRANSFER: (transferId) => `/banks/${transferId}`,
        DELETE_TRANSFER: (transferId) => `/banks/${transferId}`,
        RESTORE_TRANSFER: (transferId) => `/banks/${transferId}/restore`,
        CANCEL_TRANSFER: (transferId) => `/request-cancel/${transferId}/cancel`
    },
    SWIFT_FILES: {
    UPLOAD: (transferId) => `/swifts/${transferId}/upload`,
    GET_FILES: (transferId) => `/swifts/${transferId}`,
    UPDATE: (swiftId) => `/swifts/${swiftId}`,
    DELETE: (swiftId) => `/swifts/${swiftId}`,
    RESTORE: (swiftId) => `/swifts/${swiftId}/restore`,   // 🆕
},
    CONTAINER_FILES: {
        GET_DOCUMENTS: (containerId) => `/containers_file/${containerId}/documents`,
        UPLOAD_DOCUMENTS: (containerId) => `/containers_file/${containerId}/documents`,
        DELETE_DOCUMENTS: (containerId) => `/containers_file/${containerId}/documents`,
    },
    INVOICE_CONTAINER_CONNECTION: {
        UNLINK: (invoiceId) => `/invoice-connect/invoice-connect/invoices/${invoiceId}/unlink-container`,
        LINK_BULK: (invoiceId, containerId) => `/containers/link-invoice?invoice_id=${invoiceId}&container_id=${containerId}`,
    },
    AI_SERVICE_MANAGEMENT: {
    SAVE_DATA: '/ai-service/ai-invoices/save-ai-data',
    ANALYZE_BUNDLE: '/ai/ai/process-document/',
},
    AI_EXTRA_SERVICES: {
        COMBINE_PDFS: (invoiceId) => `/ai-services-list/combine/combine-pdfs/${invoiceId}`,
        ANALYZE_DOCUMENT: '/ai-services-list/analyze/analyze-document',
        GET_FULL_PACKAGE: (invoiceId) => `/ai-services-list/full-package/invoices/${invoiceId}/full-package`,
        SILENT_TRIGGER: '/ai-services-list/silent-update/trigger',
        FULL_SEARCH: '/ai-services-list/full-search/search',
        GET_VENDOR_SUMMARY: (vendorId) => `/ai-services-list/full/vendors/${vendorId}/invoices-summary`,
        UPLOAD_DOCUMENTS: '/ai-services-list/upload/upload',
    },
    PROFILE_UPDATE_MANAGEMENT: {
        GET_DATA: '/profile-settings/update-profile/profile-data',
        UPDATE_SETTINGS: '/profile-settings/update-profile/update-settings',
    },
    ID_STATEMENT_MANAGEMENT: {
        GET_ALL: '/id-statement/manifests/',                             // GET
        CREATE: '/id-statement/manifests/',                              // POST
        DELETE: (manifestId) => `/id-statement/manifests/${manifestId}`,  // DELETE
        UPDATE: (manifestId) => `/id-statement/manifests/${manifestId}`,  // PUT
        RESTORE: (manifestId) => `/id-statement/manifests/${manifestId}/restore`,// POST
        SEARCH_NUMBER: (manifestNumber) => `/id-statement/number-statement/search/${manifestNumber}`, // GET
        GET_DETAILS: (manifestId) => `/id-statement/id-statement/${manifestId}`, // GET
    },
    // 🔍 قسم البحث برقم البيان الجمركي (Number Statement Management)
    NUMBER_STATEMENT_MANAGEMENT: {
        SEARCH: (manifestNumber) => `/id-statement/number-statement/search/${manifestNumber}`, // GET
    },
    ARCHIVE_MANAGEMENT: {
        GET_COMPANY_ARCHIVE: '/archive/company',               // GET
    },
    ACTIVITY_LOGS: {
        CREATE: '/activity-logs/',                             // POST
        GET_ALL: '/activity-logs/',                            // GET
        DELETE: (logId) => `/activity-logs/${logId}`,          // DELETE
        RESTORE: (logId) => `/activity-logs/${logId}/restore`, // PUT
    },
   
     SCREEN_MANAGEMENT: {
        GET_SCREENS: '/screens/screens/screens',  
        GET_ACTIONS: '/screens/actions/actions',             
    },
    ROLE_MANAGEMENT: {
        UPDATE_PERMISSIONS: '/roles/roles/permissions/update', 
        GET_TEMPLATES: '/roles/roles/templates',               
    },
    ADMIN_MANAGEMENT: {
        ACTIVATE_ACCOUNT: '/activate/activate/activate', 
        DELETE_MEMBER: (userId) => `/admin/users/${userId}`, 
    },

    // 🔑 قسم إدارة الأدوار والصلاحيات الأولى (Role Management)

    // 🔄 قسم تحديث الأدوار والصلاحيات الثانية (Update Role Management)
    UPDATE_ROLE_MANAGEMENT: {
        UPDATE_PERMISSIONS: '/update-role/permissions/update', 
        GET_ALL_MEMBERS: '/update-role/users/all',             
        DELETE_MEMBER: (userId) => `/update-role/users/${userId}`, 
        GET_USER: (userId) => `/update-role/users/${userId}`,      
        UPDATE_MEMBER: (userId) => `/update-role/users/${userId}`,  
    },

    // 🖥️ قسم إدارة الشاشات والعمليات
    
    // 🧑‍💻 قسم إدارة المستخدم الحالي والأعضاء (User Management)
    USER_MANAGEMENT: {
        GET_ME: '/users/users/me',                                      // GET
        GET_COMPANY_MEMBERS: '/users/users/company-members',            // GET
        UPDATE_PROFILE: '/users/users/update-profile',                  // PUT
        ACCESS_TEST_SCREEN: '/users/users/test-screen-1',               // GET
        GET_MY_PERMISSIONS: '/users/users/me/permissions',              // GET
    },
    INVITATION: {
        INVITE_USER: '/invite/invite', 
        GET_ALL: '/invite/all',
        ACTIVATE: (token) => `/activate?token=${token}`, // 🎯 مضافة للتوافق مع activate_router
        SEND_TEST_EMAIL: '/send-email/send-test-email',  // 🎯 مضافة للتوافق مع send_email_router
    },
    USER_PERMISSIONS: {
    GET_CUSTOM: (userId) => `users/users/${userId}/custom-permissions`,
    UPDATE_CUSTOM: (userId) => `users/users/${userId}/custom-permissions`,
    GET_MY_PERMISSIONS: '/users/users/me/role-permissions',
},

};